/**
 * Potkleurfamilies in de potconfigurator.
 *
 * Elke potkleur is bij Florafy een apart product, dus toonde de configurator
 * vier bijna identieke kaarten per model. De familie komt uit het metafield
 * custom.pot_kleur_familie; Liquid en de progressieve loader leveren hetzelfde
 * JSON-contract per familie. De bovenste potkaart toont alleen een passieve
 * voorvertoning. De aparte kleurkiezer gebruikt de familiedata om een kleur te
 * kiezen en de kaart als één geheel bij te werken.
 *
 * Zonder volledige familiedata staat er geen familiecontract in de DOM en doet dit script
 * niets - de kaarten gedragen zich dan exact zoals voorheen.
 */

(function () {
  'use strict';

  var COLOR_OPTION_SELECTOR = '.js-pot-color-option';
  var COLOR_QUICKVIEW_SELECTOR = '.js-pot-color-option-quickview';
  var CHOOSER_SELECTOR = '.js-pot-color-chooser';
  var FAMILY_DATA_SELECTOR = '.js-pot-color-family-data';
  var POT_LABEL_SELECTOR = '.js-select-pot';
  var CARD_SELECTOR = '.related-pots';
  var rememberedColors = {};
  var DIAMETER_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
    '<circle cx="12" cy="12" r="9"/><line x1="5" y1="12" x2="19" y2="12"/>' +
    '<line x1="5" y1="11" x2="5" y2="13"/><line x1="19" y1="11" x2="19" y2="13"/></svg>';

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var quickview = event.target.closest(COLOR_QUICKVIEW_SELECTOR);
    if (quickview) return;

    var option = event.target.closest(COLOR_OPTION_SELECTOR);
    if (option) {
      event.preventDefault();
      selectColor(option);
      return;
    }

    var label = event.target.closest(POT_LABEL_SELECTOR);
    if (!label) return;

    var card = label.closest(CARD_SELECTOR);
    if (!card) return;
    syncChooserWithCard(card);
  });

  document.addEventListener('change', function (event) {
    if (!event.target.closest || !event.target.classList.contains('pot-color-option__radio')) return;
    var option = event.target.closest(COLOR_OPTION_SELECTOR);
    if (option) selectColor(option);
  });

  function syncChooserWithCard(card) {
    var input = card.querySelector('.related-pots__input');
    if (!input || !input.checked) {
      closeChooser();
      return;
    }

    var family = readFamily(card);
    if (family.length < 2) {
      closeChooser();
      return;
    }

    var familyId = card.dataset.potFamilyId || '';
    var selected = rememberedColors[familyId] || findCurrentColor(card, family) || family[0];
    var current = findCurrentColor(card, family);

    // Een kaart kan opnieuw zijn opgebouwd terwijl de bezoeker voor deze familie
    // al een kleur koos. Herstel dan eerst de echte potselectie en render daarna.
    if (current && String(current.variant_id) !== String(selected.variant_id)) {
      applySwatch(card, selected);
      return;
    }

    rememberedColors[familyId] = selected;
    renderChooser(card, family, selected);
  }

  function selectColor(option) {
    var card = findFamilyCard(option.dataset.potFamilyId);
    if (!card) return;

    var optionRadio = option.querySelector('.pot-color-option__radio');
    var restoreFocus = document.activeElement === optionRadio;

    var family = readFamily(card);
    var selected = family.find(function (item) {
      return String(item.variant_id) === String(option.dataset.variantId);
    });
    if (!selected) return;

    Array.prototype.forEach.call(option.parentNode.querySelectorAll(COLOR_OPTION_SELECTOR), function (candidate) {
      var isSelected = candidate === option;
      candidate.classList.toggle('is-selected', isSelected);
      candidate.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      var radio = candidate.querySelector('.pot-color-option__radio');
      if (radio) radio.checked = isSelected;
    });
    rememberedColors[card.dataset.potFamilyId || ''] = selected;
    applySwatch(card, selected);
    if (restoreFocus) focusSelectedRadio();
  }

  function focusSelectedRadio() {
    var chooser = document.querySelector(CHOOSER_SELECTOR);
    if (!chooser) return;
    var radios = chooser.querySelectorAll('.pot-color-option__radio');
    for (var index = 0; index < radios.length; index += 1) {
      if (radios[index].checked && radios[index].focus) {
        radios[index].focus();
        return;
      }
    }
  }

  function findFamilyCard(familyId) {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    for (var index = 0; index < cards.length; index += 1) {
      if (String(cards[index].dataset.potFamilyId || '') === String(familyId || '')) {
        return cards[index];
      }
    }
    return null;
  }

  function readFamily(card) {
    var source = card.querySelector(FAMILY_DATA_SELECTOR);
    var quickview = card.querySelector('.js-quickview-toggle');
    var variantTitle = quickview && quickview.dataset.variantTitle;
    if (!source || !variantTitle) return [];

    try {
      var parsed = JSON.parse(source.textContent || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.map(normalizeFamilyItem).filter(function (item) {
        return (
          String(item.variant_title) === String(variantTitle) &&
          item.product_id &&
          item.variant_id &&
          item.color_name &&
          item.color_hex
        );
      });
    } catch (error) {
      return [];
    }
  }

  function findCurrentColor(card, family) {
    var input = card.querySelector('.related-pots__input');
    if (!input) return null;
    return (
      family.find(function (item) {
        return (
          String(item.product_id) === String(input.dataset.productId) &&
          String(item.variant_id) === String(input.value)
        );
      }) || null
    );
  }

  function renderChooser(card, family, selected) {
    var chooser = document.querySelector(CHOOSER_SELECTOR);
    if (!chooser) return;

    var heading = chooser.querySelector('.js-pot-color-heading');
    var count = chooser.querySelector('.js-pot-color-count');
    var options = chooser.querySelector('.js-pot-color-options');
    if (!heading || !count || !options) return;

    heading.textContent = template(chooser.dataset.headingTemplate, '__COLOR__', selected.color_name);
    count.textContent = template(chooser.dataset.countTemplate, '__COUNT__', family.length);
    options.innerHTML = '';
    options.setAttribute('role', 'radiogroup');

    family.forEach(function (item) {
      options.appendChild(buildColorOption(card.dataset.potFamilyId || '', item, selected, chooser));
    });

    chooser.hidden = false;
  }

  function buildColorOption(familyId, item, selected, chooser) {
    var isSelected = String(item.variant_id) === String(selected.variant_id);
    var option = document.createElement('div');
    option.className = 'pot-color-option js-pot-color-option' + (isSelected ? ' is-selected' : '');
    option.setAttribute('data-pot-family-id', familyId);
    option.setAttribute('data-variant-id', item.variant_id);
    option.setAttribute('data-color-name', item.color_name);
    var radio = document.createElement('input');
    radio.className = 'pot-color-option__radio';
    radio.setAttribute('type', 'radio');
    radio.setAttribute('name', 'pot-color-' + familyId);
    radio.setAttribute('value', item.variant_id);
    radio.setAttribute('aria-label', item.color_name);
    radio.checked = isSelected;
    option.appendChild(radio);

    var image = document.createElement('img');
    image.className = 'pot-color-option__image';
    image.setAttribute('src', item.image_200);
    image.setAttribute('alt', item.image_alt || item.title);
    image.setAttribute('width', '120');
    image.setAttribute('height', '120');
    image.setAttribute('loading', 'lazy');
    image.setAttribute('decoding', 'async');
    option.appendChild(image);

    var name = document.createElement('span');
    name.className = 'pot-color-option__name';
    name.textContent = item.color_name;
    option.appendChild(name);

    var quickview = document.createElement('button');
    quickview.className = 'pot-color-option__quickview js-pot-color-option-quickview js-quickview-toggle';
    quickview.setAttribute('type', 'button');
    quickview.setAttribute('aria-label', template(chooser.dataset.quickviewTemplate, '__COLOR__', item.color_name));
    quickview.setAttribute('data-title', item.title + ' - ' + item.variant_title);
    quickview.setAttribute('data-variant-title', item.variant_title);
    quickview.setAttribute('data-price', item.price);
    quickview.setAttribute('data-description', item.description || '');
    quickview.setAttribute('data-url', item.url);
    quickview.setAttribute('data-image', item.image_600);
    quickview.setAttribute('data-bs-toggle', 'modal');
    quickview.setAttribute('data-bs-target', '#exampleModal');
    quickview.innerHTML = '<i class="fa-sharp fa-solid fa-magnifying-glass" aria-hidden="true"></i>';
    option.appendChild(quickview);

    return option;
  }

  function closeChooser() {
    var chooser = document.querySelector(CHOOSER_SELECTOR);
    if (!chooser) return;
    var options = chooser.querySelector('.js-pot-color-options');
    if (options) options.innerHTML = '';
    chooser.hidden = true;
  }

  function template(value, token, replacement) {
    return String(value || '').replace(token, String(replacement == null ? '' : replacement));
  }

  /**
   * Wissel de kaart naar de gekozen kleur en selecteer hem.
   */
  function applySwatch(card, data) {
    var input = card.querySelector('.related-pots__input');
    var label = card.querySelector('.js-select-pot');
    if (!input || !label) return;

    var diameter = normalizeDiameter(data.pot_diameter);

    setData(input, 'diameter', diameter);
    setData(input, 'product-id', data.product_id);
    setData(input, 'pot-price', data.price);
    setData(input, 'pot-compare-price', data.compare_at_price || '0');
    input.value = String(data.variant_id);
    input.id = 'pot-' + data.variant_id;
    label.setAttribute('for', input.id);

    updatePrice(label, data.price_formatted);
    updateImage(label, data.image_200, data.image_alt || data.title);
    updateDiameterBadge(label, diameter);
    updateQuickview(card, data);

    // Laat de bestaande PotFinder-handler het werk doen: die vult de quickview,
    // kiest de juiste oppot-optie en herberekent het totaal. De radio wordt eerst
    // losgelaten omdat die handler de checked-state omklapt.
    input.checked = false;
    label.click();
  }

  function updatePrice(label, priceFormatted) {
    var price = label.querySelector('.related-pots__price');
    var spans = price ? price.querySelectorAll('span') : [];
    if (spans.length < 2) return;
    var parts = String(priceFormatted == null ? '' : priceFormatted).split(',');
    spans[0].textContent = parts[0] + ',';
    spans[1].textContent = parts[1] || '';
  }

  function updateImage(label, src, alt) {
    var img = label.querySelector('img');
    if (!img || !src) return;
    // De srcset hoort bij het vorige product; een 200x200 dekt de 100px-kaart.
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.setAttribute('src', src);
    img.setAttribute('alt', alt || '');
  }

  function updateDiameterBadge(label, diameter) {
    var badge = label.querySelector('.related-pots__diameter');
    if (!diameter) {
      if (badge) badge.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'related-pots__diameter';
      label.appendChild(badge);
    }
    badge.innerHTML = DIAMETER_SVG + ' ' + escapeHtml(diameter) + 'cm';
  }

  function updateQuickview(card, data) {
    var quickview = card.querySelector('.js-quickview-toggle');
    if (!quickview) return;
    setData(quickview, 'title', data.title + ' - ' + data.variant_title);
    setData(quickview, 'variant-title', data.variant_title);
    setData(quickview, 'price', data.price);
    setData(quickview, 'description', data.description || '');
    setData(quickview, 'url', data.url);
    setData(quickview, 'image', data.image_600);
  }

  function normalizeDiameter(value) {
    if (!value || value === '0') return '';
    return String(value);
  }

  /**
   * Zet het attribuut en, wanneer jQuery aanwezig is, ook de datacache. app.js
   * leest deze waarden met $.fn.data(), en die cachet bij de eerste uitlezing:
   * alleen setAttribute laat de kaart dus met de oude kleur in de cart belanden.
   */
  function setData(element, key, value) {
    var stringValue = value == null ? '' : String(value);
    element.setAttribute('data-' + key, stringValue);
    if (!window.jQuery) return;
    var $element = window.jQuery(element);
    $element.data(key, stringValue);
    $element.data(camelize(key), stringValue);
  }

  function camelize(key) {
    return key.replace(/-([a-z])/g, function (match, letter) {
      return letter.toUpperCase();
    });
  }

  function escapeHtml(text) {
    return String(text == null ? '' : text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  /**
   * Het gedeelde bovenkaartcontract voor kaarten die de loader later toevoegt.
   * De indicators zijn bewust spans: de bovenkaart kiest het potmodel, niet de
   * kleur. De volledige, gefilterde familiedata blijft beschikbaar voor de
   * aparte kleurkiezer.
   */
  function buildFamilyCardHtml(items, labels, familyId) {
    var family = items.map(normalizeFamilyItem);
    var summaryTemplate = (labels && labels.familySummary) || '__COUNT__';
    var preview = family
      .slice(0, 4)
      .map(function (item) {
        return (
          '<span class="pot-color-preview__dot" aria-hidden="true"' +
          ' style="background-color: ' + escapeHtml(item.color_hex) + ';"></span>'
        );
      })
      .join('');
    var hiddenCount = family.length - 4;
    if (hiddenCount > 0) {
      preview += '<span class="pot-color-preview__more" aria-hidden="true">+' + hiddenCount + '</span>';
    }

    return (
      '<div class="pot-color-preview" role="img" aria-label="' +
      escapeHtml(summaryTemplate.replace('__COUNT__', String(family.length))) +
      '">' +
      preview +
      '</div>' +
      '<script type="application/json" class="js-pot-color-family-data" data-family-id="' +
      escapeHtml(familyId) +
      '">' +
      safeJson(family) +
      '</script>'
    );
  }

  function normalizeFamilyItem(item) {
    return {
      product_id: item.product_id,
      variant_id: item.variant_id,
      variant_title: item.variant_title,
      title: item.title,
      color_name: item.color_name,
      color_hex: item.color_hex,
      price: item.price,
      price_formatted: item.price_formatted,
      compare_at_price: item.compare_at_price || 0,
      pot_diameter: item.pot_diameter || 0,
      description: item.description || '',
      url: variantUrl(item.url, item.variant_id),
      image_200: item.image_200 || '',
      image_600: item.image_600 || '',
      image_alt: item.image_alt || item.title,
    };
  }

  function variantUrl(url, variantId) {
    var value = String(url || '');
    if (!value || /[?&]variant=/.test(value)) return value;
    return value + (value.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
  }

  function safeJson(value) {
    return JSON.stringify(value)
      .replace(/</g, '\\u003c')
      .replace(/>/g, '\\u003e')
      .replace(/&/g, '\\u0026');
  }

  window.PotColorSwatches = {
    buildFamilyCardHtml: buildFamilyCardHtml,
  };
})();
